/**
 * 环境变量配置
 */

// 获取环境变量
export const getEnv = (key: keyof ImportMetaEnv): string => {
  return import.meta.env[key] || ''
}

// 当前环境
export const getCurrentEnv = (): string => {
  return getEnv('VITE_CURRENT_ENV')
}

// 是否为开发环境
export const isDev = (): boolean => {
  return getCurrentEnv() === 'dev'
}

// 是否为测试环境
export const isTest = (): boolean => {
  return getCurrentEnv() === 'test'
}

// 是否为生产环境
export const isProd = (): boolean => {
  return getCurrentEnv() === 'prod'
}

// 获取代理域名
export const getProxyUrl = (): string => {
  return getEnv('VITE_PROXY_URL')
}

// 获取登录重定向URL
export const getLoginRedirectUrl = (): string => {
  return getEnv('VITE_LOGIN_REDIRECT_URL')
}

// 获取默认语言
export const getDefaultLang = (): string => {
  return getEnv('VITE_DEFAULT_LANG')
}

// 获取Firebase配置
export const getFirebaseConfig = (): any => {
  try {
    return JSON.parse(getEnv('VITE_FIREBASE_CONFIG'))
  } catch (error) {
    console.error('解析Firebase配置失败:', error)
    return {}
  }
}

// 获取加密公钥
export const getEncryptPublicKey = (): string => {
  return getEnv('VITE_ENCRYPT_PUBLIC_KEY')
}

// 获取品牌名称
export const getBrandName = (): string => {
  return getEnv('VITE_BRAND_NAME')
}

// 获取S3 URL
export const getS3Url = (): string => {
  return getEnv('VITE_S3_URL')
}

// 获取API入口文件地址
export const getApiEntryFileAddr = (): string => {
  return getEnv('VITE_API_ENTRY_FILE_ADDR')
}

// 获取Telegram APP ID
export const getTelegramAppId = (): string => {
  return getEnv('VITE_TG_APP_ID')
}

// 获取Telegram APP 名称
export const getTelegramAppName = (): string => {
  return getEnv('VITE_TG_APP_NAME')
}

// 环境变量配置对象
export const envConfig = {
  currentEnv: getCurrentEnv(),
  isDev: isDev(),
  isTest: isTest(),
  isProd: isProd(),
  proxyUrl: getProxyUrl(),
  loginRedirectUrl: getLoginRedirectUrl(),
  defaultLang: getDefaultLang(),
  firebaseConfig: getFirebaseConfig(),
  encryptPublicKey: getEncryptPublicKey(),
  brandName: getBrandName(),
  s3Url: getS3Url(),
  apiEntryFileAddr: getApiEntryFileAddr(),
  telegramAppId: getTelegramAppId(),
  telegramAppName: getTelegramAppName()
}

export default envConfig
